import React from "react";
import Logo from '../../../assets/images/1.png';
import Profile from '../../../assets/images/profile-img.jpg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faCoffee } from '@fortawesome/free-solid-svg-icons';
import { faBell, faList } from "../../../../node_modules/@fortawesome/free-solid-svg-icons/index";
import NFSM from '../../../assets/images/5.png';
import $ from "jquery"
import './AdminSideBar'
import '../Styles/NSFMStyle.css';
import { Link } from "react-router-dom";
const AdminHeaderNFSM = () => {

    function capitalFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }  

    function mySidebarToggle() {
        var element = document.getElementById("myDIV");
        element.classList.toggle("mystyle");
        var element2 = document.getElementById("main");
    element2.classList.toggle("fullDiv");
    }

 return (
    <>
    <div id="header" className="header fixed-top d-flex align-items-center">
             <div className="d-flex align-items-center justify-content-between">
                 <i className="toggle-sidebar-btn"><FontAwesomeIcon icon={faBars} onClick={mySidebarToggle} /></i>
            
      {/* <a href="/" className="logo d-flex align-items-center innerLogo">
                     <img src={NaturalFarming}/></a> */}
                     <Link
              to="/nfsm/dashboard"
              className="logo d-flex align-items-center innerLogo"
            >
              <img src={NFSM} style={{ width: "73px" }} />
            </Link>
                
    </div>
  

    <div className="header-nav ms-auto">
      <ul className="d-flex align-items-center">
            

        <li className="nav-item dropdown pe-3">

          <a className="nav-link nav-profile d-flex align-items-center pe-0"  data-bs-toggle="dropdown">
            <img src={Profile} alt="Profile" className="rounded-circle"/>
                             <span className="d-none d-md-block dropdown-toggle ps-2">{capitalFirstLetter(localStorage.getItem("username"))}</span>
          </a>

          <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow profile">
            <li className="dropdown-header">
              <h6>{capitalFirstLetter(localStorage.getItem("username"))}</h6>
            
            </li>
            {/* <li>
              <hr className="dropdown-divider"/>
            </li> */}

            {/*<li>*/}
            {/*  <a className="dropdown-item d-flex align-items-center" href="users-profile.html">*/}
            {/*    <i className="bi bi-person"></i>*/}
            {/*    <span>My Profile</span>*/}
            {/*  </a>*/}
            {/*</li>*/}
           
            <li>
              <hr className="dropdown-divider"/>
            </li>
            <li>
              <a className="dropdown-item d-flex align-items-center" href="#">
                <i className="bi bi-box-arrow-right"></i>
                <span>Sign Out</span>
              </a>
            </li>

          </ul>
        </li>
      </ul>
    </div>
  </div>
    </>

 )

}

export default AdminHeaderNFSM